import { ref } from 'vue'

const showLoader = ref(false)

export const useLoader = () => {
  const toggleShowLoader = state => {
    showLoader.value = state
  }

  return { toggleShowLoader, showLoader }
}
